import { appServiceClient } from '@/infrastructure/http/httpClient';

import {
  IConfigInstitucional,
  ICreateFeriadoPayload,
  IUpdateConfigPayload,
  IUpdateFeriadoPayload,
} from '../interfaces/configuracao';

class ConfiguracaoRepository {
  async get(): Promise<IConfigInstitucional> {
    return appServiceClient.get<IConfigInstitucional>('config-institucional');
  }

  async update(payload: IUpdateConfigPayload): Promise<IConfigInstitucional> {
    return appServiceClient.patch<IConfigInstitucional>('config-institucional', { body: payload });
  }

  async addFeriado(payload: ICreateFeriadoPayload): Promise<IConfigInstitucional> {
    return appServiceClient.post<IConfigInstitucional>('config-institucional/feriados', {
      body: payload,
    });
  }

  async updateFeriado(id: string, payload: IUpdateFeriadoPayload): Promise<IConfigInstitucional> {
    return appServiceClient.patch<IConfigInstitucional>(`config-institucional/feriados/${id}`, { body: payload });
  }

  /** Deleting ARCHIVES: the holiday leaves `feriados` and lands in `feriadosExcluidos`. */
  async removeFeriado(id: string): Promise<IConfigInstitucional> {
    return appServiceClient.delete<IConfigInstitucional>(`config-institucional/feriados/${id}`);
  }

  /** Takes the holiday out of the trash. No body: the id is all the write needs. */
  async restaurarFeriado(id: string): Promise<IConfigInstitucional> {
    return appServiceClient.post<IConfigInstitucional>(`config-institucional/feriados/${id}/restaurar`);
  }

  async removeFeriadoDefinitivo(id: string): Promise<IConfigInstitucional> {
    return appServiceClient.delete<IConfigInstitucional>(`config-institucional/feriados/${id}/definitivo`);
  }

  /** Confirming and undoing share the route: the body says the STATE, not the action. */
  async setFeriadoConfirmado(id: string, confirmado: boolean): Promise<IConfigInstitucional> {
    return appServiceClient.patch<IConfigInstitucional>(`config-institucional/feriados/${id}/confirmacao`, {
      body: { confirmado },
    });
  }

  async setOrigemConfirmada(campo: string, confirmado: boolean): Promise<IConfigInstitucional> {
    return appServiceClient.patch<IConfigInstitucional>(`config-institucional/origins/${campo}/confirmacao`, {
      body: { confirmado },
    });
  }
}

export const configuracaoRepository = new ConfiguracaoRepository();
